<div class="p-5 pt-0 text-primary-darkest">
  <div class="mb-5 flex items-center space-x-3">
    <span class="mt-1 h-1 w-12 bg-primary-md-dark"></span>
    <h1 class="relative text-2xl font-semibold lg:text-3xl">
      My Beautybook Post
    </h1>
  </div>
  <!-- right section -->
  <div class="rounded-xl border border-primary-md-dark py-9">
    <div class="mx-auto max-w-md text-center">
      <div
        class="bg-gradient-to-r from-primary-darkest to-primary-md-dark bg-clip-text font-playfair-display text-4xl leading-tight text-transparent text-primary-darkest">
        BEAUTY <br />
        BOOK
      </div>
    </div>
    <div
      *ngIf="!loading"
      class="flex flex-wrap content-center justify-center gap-x-9 gap-y-6 p-9">
      <ng-container *ngFor="let post of beautybookPosts">
        <fc-beautybook-item [post]="post"></fc-beautybook-item>
        <div *ngIf="beautybookPosts.length == 0">
          <div class="mt-1 text-center text-primary-darkest">
            <img
              src="assets/images/product/no-result-search-dummy.png"
              class="illust mx-auto w-full max-w-[250px]" />
            <div class="text-lg font-semibold">
              You don't have any beautybook posts yet. Try making one!
            </div>
            <div class="mx-auto mt-5 w-1/3 justify-center gap-5 space-y-3">
              <div
                [routerLink]="'/beautybook/add/1'"
                class="items-center gap-2">
                <div
                  class="cursor-pointer rounded-lg bg-primary-md-dark p-2 px-3 text-sm font-semibold text-white hover:bg-yellow-700">
                  Try It On
                </div>
              </div>
              <div
                [routerLink]="'/beautybook/list'"
                class="cursor-pointer rounded-lg border border-primary-md-dark bg-white p-2 px-3 text-sm font-semibold text-primary-md-dark hover:bg-primary-lightest">
                See All Posts
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <!-- skeleton start -->
    <div
      *ngIf="loading"
      class="hot-deals container mx-auto px-5 py-9 md:px-14 lg:px-20 xl:px-28">
      <div class="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-4">
        <div class="product-wishlist-loading" *ngFor="let item of [1, 2, 3, 4]">
          <p-skeleton class="w-full" height="19rem"></p-skeleton>
        </div>
      </div>
    </div>
    <!-- skeleton end -->
  </div>
  <!-- end right section -->
</div>
